import { useMutation, useQueryClient } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { MutationKeys } from '../../mutation/mutation.enum';
import { QueryKeys } from '../../querys/querys.enum';

const cancelJob = async (jobId: string): Promise<void> => {
  await automateAxios.post(`/jobs/${jobId}/cancel`);
};

const useCancelJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKeys.CANCEL_AUTOMATION_JOB],
    mutationFn: cancelJob,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AUTOMATION_JOBS] });
    },
  });
};

export default useCancelJob;
